import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogCategoryPage } from "@/components/sections/catalog-pages";
import { getCatalogCategory } from "@/lib/services-catalog";

export const Route = createFileRoute("/services/industry-solutions/")({
  component: IndustryIndex,
  head: () => ({
    meta: [
      { title: "Industry Solutions — CoderLity" },
      { name: "description", content: "Pre-built vertical software for education, healthcare and logistics — deploy in weeks, not quarters." },
      { property: "og:title", content: "Industry Solutions — CoderLity" },
      { property: "og:description", content: "Vertical software for education, healthcare and logistics." },
      { property: "og:url", content: "/services/industry-solutions" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/industry-solutions" }],
  }),
});

function IndustryIndex() {
  const cat = getCatalogCategory("industry-solutions");
  if (!cat) throw notFound();
  return <CatalogCategoryPage cat={cat} />;
}
